"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_GUIDELINE_LIMITS = void 0;
exports.countBrandGuidelineTokens = countBrandGuidelineTokens;
exports.BRAND_GUIDELINE_LIMITS = {
    /**
     * Combined budget for every active guideline. New guidelines stop here.
     * Edits to guidelines already saved are allowed past it.
     */
    TOKEN_BUDGET: 3000,
};
/**
 * Guideline budget unit: 4 characters per token, the usual model estimate.
 * Shared so the settings UI and the API stop at the same ceiling.
 */
function countBrandGuidelineTokens(content) {
    return Math.ceil(content.length / 4);
}
